import React, {
  lazy,
  useMemo,
} from 'react';

// import Home from 'pages/Home';
import { ROUTE_PATHS } from 'utils/constants';

const EditAgent = lazy(() => import('pages/EditAgent'));
const CreateAgent = lazy(() => import('pages/CreateAgent'));
const Agent = lazy(() => import('pages/Agent'));
const CustomerAccount = lazy(() => import('pages/CustomerAccount'));
const ImportUser = lazy(() => import('pages/ImportUser'));
const DataTag = lazy(() => import('pages/DataTag'));
const MonitorDashboard = lazy(() => import('pages/MonitorDashboard'));
const OverView = lazy(() => import('pages/OverView'));
const Provider = lazy(() => import('pages/Provider'));
const PlanInactive = lazy(() => import('pages/PlanDeactive'));
const ComingSoonPage = lazy(() => import('components/templates/ComingSoonPage'));

type RouteType = {
  path?: string;
  element: React.ReactNode;
  isProtected: boolean;
  childrens?: Array<RouteType>;
};

const useRoutesList = () => {
  const routes: { [key: string]: RouteType } = useMemo(
    () => ({
      // home: {
      //   path: ROUTE_PATHS.HOME,
      //   element: <Home />,
      //   isProtected: true
      // },
      // login: {
      //   path: ROUTE_PATHS.LOGIN,
      //   element: <Login />,
      //   isProtected: false,
      // },
      // loginGoogle: {
      //   path: ROUTE_PATHS.LOGIN_GOOGLE,
      //   element: <LoginGoogle />,
      //   isProtected: false,
      // },
      // loginMicrosoft: {
      //   path: ROUTE_PATHS.LOGIN_MICROSOFT,
      //   element: <LoginMicrosoft />,
      //   isProtected: false,
      // },
      monitorDashboard: {
        path: ROUTE_PATHS.MONITOR_DASHBOARD,
        element: <MonitorDashboard />,
        isProtected: true,
      },
      agent: {
        path: ROUTE_PATHS.AGENT,
        element: <Agent />,
        isProtected: true,
      },
      editAgent: {
        path: ROUTE_PATHS.EDIT_AGENT,
        element: <EditAgent />,
        isProtected: true,
      },
      createAgent: {
        path: ROUTE_PATHS.CREATE_AGENT,
        element: <CreateAgent />,
        isProtected: true,
      },
      customerAccount: {
        path: ROUTE_PATHS.CUSTOMER_ACCOUNTS,
        element: <CustomerAccount />,
        isProtected: true,
      },
      dataTag: {
        path: ROUTE_PATHS.DATATAG,
        element: <DataTag />,
        isProtected: true,
      },
      importUser: {
        path: ROUTE_PATHS.IMPORT_USER,
        element: <ImportUser />,
        isProtected: true,
      },
      overview: {
        path: ROUTE_PATHS.OVER_VIEW,
        element: <OverView />,
        isProtected: true,
      },
      provider: {
        path: ROUTE_PATHS.PROVIDER,
        element: <Provider />,
        isProtected: true,
      },
      planInactive: {
        path: ROUTE_PATHS.PLAN_INACTIVE,
        element: <PlanInactive />,
        isProtected: true,
      },
      role: {
        path: ROUTE_PATHS.ROLE,
        element: <ComingSoonPage name="Role" />,
        isProtected: true,
      },
      authUser: {
        path: ROUTE_PATHS.AUTH_USER,
        element: <ComingSoonPage name="User" />,
        isProtected: true,
      },
    }),
    []
  );

  return {
    routes,
  };
};

export default useRoutesList;
